import type { NodeSn } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphData,
  nodesDataFromIds,
} from 'components/Graph/model/GraphData';
import { readonlyArray } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';

export const getHiddenNodeSns = (graph: GraphData): NodeSn[] =>
  pipe(
    graph.hiddenNodes,
    plainSet.toArray,
    nodesDataFromIds(graph.nodes),
    readonlyArray.map(prop('sn')),
    readonlyArray.toArray,
  );
